import { Component } from '@angular/core';
import { Subject } from 'rxjs';
import { first } from 'rxjs/operators';
import { County } from '../../foundation/models/enums/county.enum';
import { Jurisdiction } from '../../foundation/models/enums/jurisdiction.enum';
import { BaseComponent } from '../../shared/base-components/base.component';
import { ContactMethodType } from '../models/enums/contact-method-type.enum';
import { CustomerAccountService } from './service/customer-account.service';

@Component({
    selector: 'customer-account-details',
    templateUrl: './customer-account-details.html',
    outputs: ['editClicked', 'requestDisbursementClicked', 'serviceHistoryClicked'],
    inputs: ['customerAccountNumber']
})
export class CustomerAccountDetailsComponent extends BaseComponent {
    public customerAccountNumber: number;
    public customerAccount: any;
    public preferredContactMethod: any;
    public editClicked: Subject<any>;
    public requestDisbursementClicked: Subject<any>;
    public serviceHistoryClicked: Subject<any>;
    public counties = new County();
    public states = new Jurisdiction();
    public contactMethods = new ContactMethodType();

    private correspondenceContactTypes: any[];

    public customerManagedAccount = true;

    constructor(private customerAccountService: CustomerAccountService) {
        super();

        this.editClicked = new Subject<any>();

        this.requestDisbursementClicked = new Subject<any>();

        this.serviceHistoryClicked = new Subject<any>();

        this.correspondenceContactTypes = [this.contactMethods.AlternativeEmail.id, this.contactMethods.BusinessEmail.id, this.contactMethods.PersonalEmail.id, this.contactMethods.BusinessCell.id, this.contactMethods.PersonalCell.id];
    }

    public async ngOnInit() {
        this.UseHelpContent('#CONTENT/AZ_MVD_Now/Customer_Account_Details.htm%3FTocPath%3DAZ%2520MVD%2520Now%7C_____2');

        this.customerAccount = await this.customerAccountService.getCustomerAccountDetails(this.customerAccountNumber).pipe(first()).toPromise();

        if (this.customerAccount.isRedactEnabled && this.customerAccount.accountAddress) {
            this.customerAccount.accountAddress.jurisdictionId = null;
            this.customerAccount.accountAddress.countyId = null;
        }

        this.customerManagedAccount = this.customerAccount.customerManagedAccount;

        this.preferredContactMethod = this.getPreferredContactTypeValue();
    }

    public editIconClicked() {
        this.editClicked.next(this.customerAccountNumber);
    }

    public requestDisbursementLinkClicked() {
        this.requestDisbursementClicked.next(this.customerAccountNumber);
    }

    public serviceHistoryLinkClicked() {
        this.serviceHistoryClicked.next(this.customerAccountNumber);
    }

    public getValues(id: number, types: any): string {
        if (id !== undefined && id !== null) {
            var type = types.FromId(id);

            if (type !== undefined) {
                return type.displayValue;
            }
        } else {
            return '';
        }
    }

    public getPreferredContactTypeValue(): any {
        var type = 'Mail';
        this.customerAccount.accountContacts.forEach(contact => {
            if (contact.isPreferredContactMethod) {
                if (contact.contactMethodTypeID == this.contactMethods.PersonalCell.id || contact.contactMethodTypeID == this.contactMethods.BusinessCell.id ||
                    contact.contactMethodTypeID == this.contactMethods.HomeLandline.id || contact.contactMethodTypeID == this.contactMethods.BusinessLandline.id) {
                    type = 'Phone';
                }
                if (contact.contactMethodTypeID == this.contactMethods.PersonalEmail.id || contact.contactMethodTypeID == this.contactMethods.BusinessEmail.id ||
                    contact.contactMethodTypeID == this.contactMethods.AlternativeEmail.id) {
                    type = 'Email';
                }
            }
        });
        return type;
    }
}
